export const styles = {
  container: {
    padding: "0 20px",
    backgroundColor: "#FFFFFF",
    maxWidth: "1004px !important",
    height: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    maxHeight: "100vh",
    overflow: "hidden",
  },
  tableContainer: {
    flex: 1,
    overflow: "auto",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    maxHeight: "none",
  },

  tableHeadCell: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#F5F9FE",
    padding: "14px 24px",
    fontSize: "16px",
    color: "#2A2D31",
    fontWeight: 600,
  },

  tableBody: {
    //   overflowY: "auto",
    //   maxHeight: "90%",
  },
  header: {
    height: "69px",
    gap: "20px",
    display: "flex",
    // flexDirection: "column",
    padding: "14px 0px 14px 0px",
    justifyContent: "space-between",
    flexShrink: 0,
  },
  title: {
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    // margin: "0 97px 20px 0",
  },
  tableHead: {
    height: "48px",
    "& .MuiTableRow-root:last-of-type .MuiTableCell-root": {
      borderBottom: "none",
    },
  },

  Arrow: {
    ml: 1,
    cursor: "pointer",
  },
  tableHeadText: {
    maxWidth: "80px",
    height: "20px",
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0%",
    whiteSpace: "nowrap",
    marginRight: "10px",
  },
  tableHeadTextRemove: {
    padding: "0px 11px",
    color: "#A0A6AF",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0%",
  },
  tableCell: {
    border: "none",
  },
  nameCellBox: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  },
  ArrowsDiagram: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  nameText: {
    fontWeight: 600,
  },
  symbolText: {
    fontSize: "0.75rem",
    color: "#76839b",
  },
  sentimentBox: (color: "green" | "red") => ({
    display: "flex",
    alignItems: "center",
    color: color === "green" ? "#00c853" : "#d32f2f",
    fontWeight: 500,
  }),
  sentimentIconBox: {
    ml: 1,
  },
  likeBox: {
    display: "flex",
    alignItems: "center",
    color: "#d32f2f",
  },
  starButton: {
    color: "#007bff",
  },
  select: {
    width: "220px",
    backgroundColor: "#F7F9FB",
    color: "#9DA6B0",
    borderRadius: "12px",
    height: "36px",
    fontSize: "14px",
    marginRight: "16px",
    ".MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    ".MuiSvgIcon-root": {
      color: "#9DA6B0",
    },
  },

  selectBox: {
    display: "flex",
  },
  filtersWrapper: {
    display: "flex",
    height: 40,
    angle: "0 deg",
    opacity: 1,
    gap: "16px",
    marginRight: "16px",
  },
};
